<template>
  <div>
    <div
      id="title"
      class="title-background center-vertical"
      style="min-height: 100vh"
    >
      <TitleBox class="width" />
    </div>
    <hr class="red-divider-thick" />
    <div class="content-box bg-radient-light">
      <TeamBox id="team" class="width" />
    </div>
    <hr class="red-divider-thick" />
    <div
      id="gameTitles"
      class="
        content-box-left-padding content-box-right-padding
        bg-radient-light
      "
    >
      <GameTitles class="width" />
    </div>
    <hr class="red-divider-thick" />
    <div class="bg-radient-light">
      <div
        id="community"
        class="content-top-padding center-vertical center-horizontal"
        style="min-height: auto !important; padding-bottom: 2vw !important"
      >
        <CommunityBox class="width" />
      </div>

      <SocialIcons class="content-top-margin" />
    </div>
  </div>
</template>

<script>
import TitleBox from "../components/TitleBox.vue";
import TeamBox from "../components/TeamBox.vue";
import GameTitles from "../components/GameTitles.vue";
import CommunityBox from "../components/CommunityBox.vue";
import SocialIcons from "../components/SocialIcons.vue";

export default {
  components: {
    TitleBox,
    TeamBox,
    GameTitles,
    CommunityBox,
    SocialIcons,
  },
};
</script>

<style scoped>
.width {
  width: 100%;
}
.title-background {
  background-image: url("../assets/img/header_background.png");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
